import React, { Component } from 'react';
import './TitleBar.css'

import epoch_logo from '../../images/epoch-logo.svg'

class TitleBar extends Component {
  render() {
    return (
      <div className="titleBar">
        <img src={epoch_logo} alt="epoch" className="logoStyle"/>
        <div className='titleBarRight'>
            <a href='#features' style={{marginRight: "20px"}}>Features</a>
            <a href='#supports' style={{marginRight: "20px"}}>Supports</a>
            <a href='#download' className='downloadButtonStyle'>Download</a>
        </div>
      </div>
    )
  }
}

export default TitleBar
